module.exports = __webpack_public_path__ + "img/gxnhjcl_s.d122076.png";